'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "Tabs": "Polaris-SkeletonTabs__Tabs",
  "Tab": "Polaris-SkeletonTabs__Tab",
  "TabText": "Polaris-SkeletonTabs__TabText",
  "fitted": "Polaris-SkeletonTabs--fitted"
};

exports.default = styles;
